/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms } from "@src/app/model/sys/nav-item";
import { User } from "@src/app/model/user";
import { NavRoute } from "@src/app/shared/NavRoute";
import { Txn } from "@src/app/model/txn";
import { ApPageComponent } from "@src/app/modules/txn/ap-page/ap-page.component";

export const ApPageNavRoute = new NavRoute(Txn.LEDGER.AP.code, ()=>ApPageComponent, 'call_made').setCharts([
    { type: 'pie', picklist: 'typeId', excludeZero: true } as ChartParms,
    { type: 'bar', picklist: 'bCodeId', number: 'credit', excludeZero: true } as ChartParms,
    { type: 'bar', picklist: 'bCodeId', number: 'debit', excludeZero: true } as ChartParms,
]).setViews((u: User) => {
    return [
        {
            id: 'currentYear',
            name: 'Current Year',
            helpText: 'Accounts payable ledger for the current financial year; change the year filter to view a different year',
            filterFields: {
                txnCycleId: u.currentTeam.currentPeriod?.cycleId,
                txnPeriodId: 'All',
                bCodeId: 'All'
            },
        }
    ]
});
